var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.789,
    height: 15,
    viewBox: "0 0 15.789 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Calendar_2718658",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M17.789,4.368V6.737H2V4.368a.789.789,0,0,1,.789-.789H6.737v.789a.789.789,0,0,0,1.579,0V3.579h3.158v.789a.789.789,0,1,0,1.579,0V3.579H17A.789.789,0,0,1,17.789,4.368Zm0,3.947v7.895A.789.789,0,0,1,17,17H2.789A.789.789,0,0,1,2,16.211V8.316ZM5.158,11.474a.789.789,0,0,0,.789.789h4.737a.789.789,0,1,0,0-1.579H5.947A.789.789,0,0,0,5.158,11.474Zm9.474,2.368a.789.789,0,0,0-.789-.789H5.947a.789.789,0,1,0,0,1.579h7.895A.789.789,0,0,0,14.632,13.842ZM7.526,2a.789.789,0,0,0-.789.789v.789H8.316V2.789A.789.789,0,0,0,7.526,2Zm4.737,0a.789.789,0,0,0-.789.789v.789h1.579V2.789A.789.789,0,0,0,12.263,2Z",
    transform: "translate(-2 -2)",
    fill: "#fe6f59"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.71c720767e519e8a23cebe6c3cf25e16.svg";
export { ForwardRef as ReactComponent };